import { Hero } from "components/Hero";
import { Intro } from "components/Intro";
import { LARGE, WHITE } from "shared/variables";
import { MaxWidth } from "components/MaxWidth";
import { OverlapArea } from "components/OverlapArea";
import { RichText } from "components/slices/RichText";
import { SpacingSection } from "components/SpacingSection";

export const ContentHero = ({ type, title, text, image }) => {
  if (type === "Met afbeelding") {
    return <Hero image={image} title={title} text={text} />;
  }

  if (type === "Titel met intro") {
    return (
      <OverlapArea noOverlap>
        <MaxWidth>
          <Intro color={WHITE} title={title} text={text} />
        </MaxWidth>
      </OverlapArea>
    );
  }

  return (
    <SpacingSection size={LARGE}>
      <MaxWidth>
        <RichText>
          <h1>{title}</h1>
        </RichText>
      </MaxWidth>
    </SpacingSection>
  );
};
